import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ReasonOfExtensionEditService } from '../../service/reason-of-extension-edit/reason-of-extension-edit.service';

@Component({
	selector: 'app-reason-of-extension-edit',
	templateUrl: './reason-of-extension-edit.component.html',
	providers: [
		ReasonOfExtensionEditService,
		HttpModule
	]
})
export class ReasonOfExtensionEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	reasonOfExtension: FormGroup;
	ID: string;
	Nome: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;

	constructor(fb: FormBuilder, private reasonOfExtensionEditService: ReasonOfExtensionEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.reasonOfExtension = fb.group({
			'ID': '',
			'Nome': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.reasonOfExtensionEditService.loadReasonOfExtension(this.token, this.ID).subscribe(result => {
				var updateCompanyTtype = result.Result;
				this.reasonOfExtension.setValue({
					ID: updateCompanyTtype.ID,
					Nome: updateCompanyTtype.Nome,
					Ativo: updateCompanyTtype.Ativo
				});
			})
		}, error => {
			console.log(error);
		});
	}

	editReasonOfExtension(value: any) {
		console.log(value);
		this.reasonOfExtensionEditService.editReasonOfExtension(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/motivo-de-prorrogacao');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/motivo-de-prorrogacao');
	}

}



// WEBPACK FOOTER //
// ./src/app/reason-of-extension/component/reason-of-extension-edit/reason-of-extension-edit.component.ts